import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DialogEditVoucherComponent } from 'app/components/vouchers/edit/voucher-edit-dialog';
import { EditSampleComponent } from 'app/components/well/samples/edit/edit-samples.component';
import { RetestSearch } from 'app/models/retest/retest-search';
import { RetestService } from 'app/services/retest-service';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '@shared/services/shared.service';
import { VoucherLetterUpload } from 'app/models/vouchers/voucher-letter-upload';
import { VoucherService } from 'app/services/voucher-service';

@Component({
  selector: 'app-chain-of-custody-letter',
  templateUrl: './chain-of-custody-letter.component.html',
  styleUrls: ['./chain-of-custody-letter.component.scss']
})
export class ChainOfCustodyLetterComponent implements OnInit {
  
  @Input('testsRequired')
  testsRequired: string = '';
  @Input('voucherId')
  voucherId: string = '';
  @Input('testType')
  testType: string = '';
  @Input('quarter')
  quarter: number = 0;
  @Input('wellAddress')
  wellAddress: string = '';
  @Input('customerName')
  customerName: string = '';
  @Input('mailingAddress')
  mailingAddress: string = '';
  @Input('mailingCity')
  mailingCity: string = '';
  @Input('mailingState')
  mailingState: string = '';
  @Input('mailingZip')
  mailingZip: string = '';
  @Input('phone')
  phone: string = '';
  @Input('email')
  email: string = '';
  

  constructor(
    public voucherService: VoucherService, 
    public retestService: RetestService) {
    // constructor
  }

  ngOnInit(): void {
  }


 




}